<form [formGroup]="form" novalidate>
  <div class="row">
    <div class="col-xs-12 col-md-6 offset-md-3 col-xl-4 offset-xl-4">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Mezzanine</h4>
          <div class="mb-3 row">
            <label for="site" class="col-3 col-form-label">Site Postcode</label>
            <div class="col-9">
              <select id="site" formControlName="site" class="form-select">
                <option disabled hidden value="null">
                  -- Please select a postcode --
                </option>
                <option *ngFor="let opt of areaCodes | async" [value]="opt.id">
                  {{ opt.postCode }} - {{ opt.area }}
                </option>
              </select>
              <hlu-validation-message
                [validationControl]="form.get('site')"
                validationName="required"
                errorMessage="Site is required"
              >
              </hlu-validation-message>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="length" class="col-3 col-form-label">Length</label>
            <div class="col-9">
              <hlu-numeric-stepper
                id="length"
                formControlName="length"
                hluMinValue="1"
                suffixLabel="m"
              >
              </hlu-numeric-stepper>
              <hlu-validation-message
                [validationControl]="form.get('length')"
                validationName="required"
                errorMessage="Length is required"
              >
              </hlu-validation-message>
              <hlu-validation-message
                [validationControl]="form.get('length')"
                validationName="minValue"
                errorMessage="Length must be 1m or more"
              >
              </hlu-validation-message>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="width" class="col-3 col-form-label">Width</label>
            <div class="col-9">
              <hlu-numeric-stepper
                id="width"
                formControlName="width"
                hluMinValue="1"
                suffixLabel="m"
              >
              </hlu-numeric-stepper>
              <hlu-validation-message
                [validationControl]="form.get('width')"
                validationName="required"
                errorMessage="Width is required"
              >
              </hlu-validation-message>
              <hlu-validation-message
                [validationControl]="form.get('width')"
                validationName="minValue"
                errorMessage="Width must be 1m or more"
              >
              </hlu-validation-message>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="loadType" class="col-3 col-form-label">Load Type</label>
            <div class="col-9">
              <select
                id="loadType"
                formControlName="loadType"
                class="form-select"
              >
                <option disabled hidden value="null">
                  -- Please select a load type --
                </option>
                <option
                  *ngFor="let opt of loadTypeDefaults | async"
                  [value]="opt.id"
                >
                  {{ opt.description }}
                </option>
              </select>
              <hlu-validation-message
                [validationControl]="form.get('loadType')"
                validationName="required"
                errorMessage="Load type is required"
              >
              </hlu-validation-message>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-9 offset-3">
              <p>{{ loadTypeDescription | async }}</p>
            </div>
          </div>
          <div class="mb-3 row" *ngIf="form.hasError('validateArea')">
            <div class="alert alert-danger">
              The total area of the floor cannot exceed 1000m<sup>2</sup>.
              Please reduce the floor's length or width.
            </div>
          </div>
          <div class="mb-3 row">
            <label for="height" class="col-3 col-form-label">Height</label>
            <div class="col-9">
              <hlu-numeric-stepper
                id="height"
                formControlName="height"
                hluMinValue="1"
                hluMaxValue="10"
                suffixLabel="m"
              >
              </hlu-numeric-stepper>
              <hlu-validation-message
                [validationControl]="form.get('height')"
                validationName="required"
                errorMessage="Height is required"
              >
              </hlu-validation-message>
              <hlu-validation-message
                [validationControl]="form.get('height')"
                validationName="minValue"
                errorMessage="Height must be 1m or more"
              >
              </hlu-validation-message>
              <hlu-validation-message
                [validationControl]="form.get('height')"
                validationName="maxValue"
                errorMessage="Height must be 10m or less"
              >
              </hlu-validation-message>
            </div>
          </div>
          <div class="mb-3 row">
            <label for="fireProtection" class="col-3 col-form-label"
              >Fire Protection</label
            >
            <div class="col-9">
              <input
                id="fireProtection"
                formControlName="fireProtection"
                type="checkbox"
              />
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col">
              <re-captcha
                formControlName="recaptcha"
                siteKey="6Led0NkqAAAAAOMpCtC4uYTqZFX71rZTI-FpjTHY"
              ></re-captcha>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-12 d-grid">
              <hlq-generate-floor-button
                buttonClass="btn btn-primary btn-block"
                buttonTitle="Get Budget"
                (onClick)="onGetBudgetClick()"
                (onSuccess)="_onSuccess($event)"
                [disabled]="!form.valid"
              >
              </hlq-generate-floor-button>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-12 d-grid">
              <button
                type="button"
                class="btn btn-danger btn-block"
                (click)="onResetClick()"
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
